import React from 'react';

const CoverPage = React.forwardRef(({ title, subtitle, year, coverImage }, ref) => {
  return (
    <div ref={ref} className="book-page" data-density="hard" style={{ backgroundColor: '#1f2937' }}>
      <div className="absolute inset-0 overflow-hidden bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800 rounded-r-sm">
        {coverImage && (
          <img
            src={coverImage}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        <div
          className="absolute inset-0"
          style={{
            background: coverImage
              ? 'linear-gradient(to top, rgba(31,41,55,0.97) 0%, rgba(31,41,55,0.85) 35%, rgba(31,41,55,0.4) 65%, transparent 100%)'
              : 'linear-gradient(160deg, #831843 0%, #9F1239 30%, #BE185D 60%, #DB2777 100%)',
          }}
        />

        <div className="absolute inset-0 flex flex-col justify-end p-6 sm:p-8">
          <h1
            className="font-display text-2xl sm:text-3xl font-bold text-white leading-tight mb-1.5"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="text-sm sm:text-base text-gray-300 mb-4"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {subtitle}
            </p>
          )}
          <p
            className="text-3xl sm:text-4xl font-bold text-pink-400"
            style={{ fontFamily: "'Space Mono', monospace", letterSpacing: '-1px' }}
          >
            {year}
          </p>
        </div>

        <div className="absolute top-4 right-4 w-8 h-8 rounded-full border-2 border-white/20 flex items-center justify-center">
          <span className="text-white/40 text-xs">{'\u2764'}</span>
        </div>
      </div>
    </div>
  );
});

CoverPage.displayName = 'CoverPage';
export default CoverPage;
